<!--<div class="loading-spinner" *ngIf="loading" role="alert">
<div class="spinner-backdrop" role="alert" aria-label="Loading, please wait"></div>
<div class="spinner">
    <div></div>
    <div></div>
</div>
<div class="loading-text">Loading..</div>
</div>-->
<div class="search-criteria">
    <button #focusableEleTop class="focusable-element"></button>
    <div class="row" *ngIf="error">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li><button>{{errorMessage}}</button></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row search-selections">
        <div class="col-24">
            <h1 class="heading">My Clients</h1>
        </div>
        <div *ngIf="searchSummaryExpanded" class="col-24">
            <hr />
            <div class="row" *ngIf="isAdmin">
                <div class="col-24">
                    <div><span class="help-text">Which orgs would you like to search for clients? Your results will appear below.</span></div>
                    <label>Organizations</label>
                </div>
            </div>
            <div class="row" *ngIf="isAdmin">
                <div class="col-24">
                    <div class="org-searchs">
                        <fieldset class="radio">
                            <div class="options-container">
                                <input id="organizations_ALLACTIVE"
                                       value="ALLACTIVE"
                                       class="option__input"
                                       type="radio"
                                       name="organizations"
                                       (click)="setOrgValue('ALLACTIVE')"
                                       [checked]="selectedOrgValue === 'ALLACTIVE'" />
                                <label class="option" for="organizations_ALLACTIVE">All Active Organizations</label>
                                <input id="organizations_ALL"
                                       value="ALL"
                                       class="option__input"
                                       type="radio"
                                       name="organizations"
                                       (click)="setOrgValue('ALL')"
                                       [checked]="selectedOrgValue === 'ALL'" />
                                <label class="option" for="organizations_ALL">All Organizations</label>
                                <input id="organizations_CUSTOM"
                                       value="CUSTOM"
                                       class="option__input"
                                       type="radio"
                                       name="organizations"
                                       (click)="setOrgValue('CUSTOM')"
                                       [checked]="selectedOrgValue === 'CUSTOM'" />
                                <label class="option" for="organizations_CUSTOM">Build your own search</label>
                            </div>
                        </fieldset>
                        <!-- <button class="button primary" (click)="onNewOrgSearchList()">New Org List</button>-->
                    </div>
                    <div class="selected-orgs" *ngIf="selectedOrgsVisible">
                        <div class="selected-orgs-inner">
                            <div class="selected-orgs-header">
                                <div *ngIf="orgDropDownVisible" class="org-browser-header-hint">
                                    <span class="help-text">
                                        Click &quot;add&quot; in the left column to include clients from that org in your search list that will show below.
                                        Click the plus sign (+) in the right column to view the lext level in the org's downline.
                                    </span>
                                </div>
                                <button class="button primary right" (click)="showHideOrgDropDown()"><span *ngIf="!orgDropDownVisible">+</span><span *ngIf="orgDropDownVisible">-</span></button>
                            </div>
                            <div [hidden]="!orgDropDownVisible" class="org-dropdown">
                                <!--<div class="org-dropdown-header"><span (click)="hideOrgDropDown()">(x)</span></div>-->
                                <div class="org-dropdown-content">
                                    <ep-tabs>
                                        <ep-tab tabTitle="Browse">
                                            <pworg-list-container #orgListContainer
                                                                [rootOrgId]="rootOrgId"
                                                                (orgAdded)="onOrgAdd($event)"
                                                                (orgTreeNodeAdded)="onSearchResultsChanged($event)"></pworg-list-container>
                                        </ep-tab>
                                        <ep-tab tabTitle="Search">
                                            <pworg-search #orgSearch (searchResultChanged)="onSearchResultsChanged($event)" (orgAdded)="onOrgAdd($event)" [resetSearch]="resetSearch"></pworg-search>
                                        </ep-tab>
                                    </ep-tabs>
                                </div>
                            </div>
                            <div class="selected-orgs-data-table">
                                <div><span class="help-text">This is the list of orgs that will be searched. Add your application start and end dates and click &quot;Search&quot;</span></div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Org Name</th>
                                            <th>Org Short Name</th>
                                            <th>Org Status</th>
                                            <th> Hierarchy </th>
                                            <!--<th>Include downline</th>-->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let org of getSelectedOrgs()">
                                            <td><span class="link" (click)="removeOrg(org)">exclude</span></td>
                                            <td>{{org.orgName}}</td> <!-- &nbsp;<span class="tooltip"><span class="inactive" *ngIf="!org.isActive"></span><span class="tooltiptext">Inactive Organization</span></span> -->
                                            <td>{{org.orgShortName}}</td>
                                            <td>{{(org.isActive === true)?"Active":"Inactive"}}</td>
                                            <td>{{org.orgIPVString}}</td>
                                            <!--<td><span [ngClass]="{'checked': org.includeDownline, 'unchecked': !org.includeDownline}" (click)="toggleDownline(org)"></span></td>-->
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div class="row">
                <div class="col-24">
                    <p><strong>Note:  Always confirm 'Start' and 'End' dates before downloading your client activity</strong></p>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="input-wrapper">
                        <JQDatePicker for="ApplicationStartDate" id="ApplicationStartDate" [label]="'Application Start Date'" [selectedDate]="myClientsCriteria.ApplicationStartDate" 
                                      (elementClicked)="onInfoChange('ApplicationStartDate', $event)"></JQDatePicker>
                    </div>
                </div>
                <div class="col-18">
                    <div class="input-wrapper">
                        <JQDatePicker for="ApplicationEndDate" id="ApplicationEndDate" [label]="'Application End Date'"  [selectedDate]="myClientsCriteria.ApplicationEndDate"
                          
                        (elementClicked)="onInfoChange('ApplicationEndDate', $event)"></JQDatePicker>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <span *ngIf="this.isAdmin" class="help-text">If you only want to see the clients of one agent, insert the agent's SilverScript agent ID here.</span>
                    <ValidatedTextField [label]="'Agent ID'"
                                        [text]="myClientsCriteria.AgentID"
                                        (onValueChange)="onInfoChange('AgentID', $event)"
                                        [disabled]="!this.isAdmin">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="row">
                <div class="col-24">
                    <button type="submit" id="getEnrollments" class="button primary next-to-field" (click)="onGetEnrollments()">Search</button>
                    <button id="searchByMedicare" class="button primary next-to-field" (click)="searchByMedicareID()">Click here to search by Medicare ID Number</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-24">
        <router-outlet></router-outlet>
    </div>
</div>